<template>
    <div></div>
</template>

<script>
export default {
    computed: {
        toasts() {
            return this.$store.state.toasts.list;
        },
    },
    watch: {
        toasts: {
            handler() {
                this.toasts.forEach( (toast, index) => {
                    this.$toast[toast.type](toast.message);
                    this.$store.dispatch('toasts/remove', index);
                })
            },
            deep: true
        }
    }
};
</script>
